import { observer } from "mobx-react-lite";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import Container from "react-bootstrap/Container";
import { Button } from "semantic-ui-react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import { calculoFechas } from "../../Portafolio/helpers/calculoFechas";
import Pagination from "react-bootstrap/Pagination";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { useStore } from "../../../app/stores/store";

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

// import  ReporteInscritosXConvenio  from "../Reportes/InscritosXConvenio"

const apiURL = process.env.REACT_APP_API_URL;
let paginadorTotal: number;

const modTool = (p: any) => (
    <Tooltip className="tool-tipr" id="button-tooltip" {...p}>
        <p className="tool-tip-text">Detalles del Código Institucional</p>
    </Tooltip>
);
const modTool2 = (p: any) => (
    <Tooltip className="tool-tipr" id="button-tooltip" {...p}>
        <p className="tool-tip-text">Estudiantes inscritos<br></br>en el código institucional</p>
    </Tooltip>
);


export default observer(function ListConveniosInstitucion() {

    let items: any = [];
    let datain: any;

    const { userStore: { user } } = useStore();
    const [modalShow, setModalShow] = React.useState(false);
    const [institu, setInstitucion] = useState(0);

    const [currentPage, setCurrentPage] = useState(1);
    const [convenio, setConvenios] = useState([]);

    const [loading, setLoading] = useState(false);
    const handlePageClick = (numberPagina: number) => { setCurrentPage(numberPagina) };

    const [soli, setSoli] =
        useState({
            idsol: 0,
            noconv: ''
        });

    const {
        idsol,
        noconv
    } = soli;

    const listaSolicitudes = async () => {
        setLoading(true);

        const perfilAPI = apiURL + `/AccountsManager/GetEntityByUser/${user?.id}`;
        const resp = await fetch(perfilAPI);
        datain = await resp.json();
        let enti = datain.idEntidad;
        setInstitucion(enti);

        const urlp = apiURL + `/CATConvenios/GetByEntity/${institu}/${currentPage}/10/`;
        const responseConvenio = await axios(urlp);
        const { data } = responseConvenio;
        paginadorTotal = data.totalPages;

        const convenios = data.records.map(
            (dataR: {
                key: number;
                id: number;
                monto: number;
                fecha: any;
                descuento: number;
                codigoInstitucional: string;
                sgtEntidad: any;

            }) => {

                return {
                    key: dataR.id,
                    id: dataR.id,
                    fecha: dataR.fecha,
                    monto: dataR.monto,
                    descuento: dataR.descuento,
                    convenio: dataR.codigoInstitucional,
                    entidad: dataR.sgtEntidad.entidad,
                };
            }
        );
        setConvenios(convenios);
        setLoading(false);
    }; useEffect(() => { listaSolicitudes() }, [institu, currentPage]);

    for (
        let numberPagina: number = 1;
        numberPagina <= paginadorTotal;
        numberPagina++
    ) {
        items.push(
            <Pagination.Item
                key={Math.random()}
                active={currentPage === numberPagina}
                activeLabel={""}
                onClick={() => {
                    handlePageClick(numberPagina);
                }}
            >
                {numberPagina}
            </Pagination.Item>
        );
    }

    function ropm(
        id: number,
        no: string
    ) {
        setSoli({
            ...soli,
            idsol: id,
            noconv: no
        });
        setModalShow(true);
    }

    const ConvenioItems = (dataR: {
        key: number;
        id: number;
        convenio: string;
        fecha: any;
        monto: number;
        descuento: number;
    }) => {

        let montoConv = new Intl.NumberFormat("es-GT").format(dataR.monto);
        let descuentoB = dataR.descuento / 100;
        let descuentoT = dataR.monto - dataR.monto * descuentoB;
        let motoConDes = new Intl.NumberFormat("es-GT").format(descuentoT);

        function montoLogic(obj: number) {
            if (obj <= 0) {
                return "Exoneracion Total";
            } else if (obj >= 1 && dataR.descuento == 0) {
                return "Q. " + montoConv + ".00";
            } else if (obj >= 1 && dataR.descuento >= 1) {
                return "Q. " + motoConDes + ".00";
            }
        }

        return (

            <Row className="solicitudes-list">
                <Col xs={3} className="solicitud-body-sec">{dataR.convenio}</Col>
                <Col xs={3} className="solicitud-body-sec"></Col>
                <Col xs={2} className="solicitud-body-sec">{calculoFechas(dataR.fecha)}</Col>
                <Col xs={2} className="solicitud-body-sec sec-cantidad">{montoLogic(dataR.monto)}</Col>
                <Col xs={2} className="solicitud-body-sec-actions">{
                    <>
                        <Link to={`/institucion/convenios/detalle/${dataR.id}`}>
                            <OverlayTrigger
                                placement="top"
                                delay={{ show: 250, hide: 400 }}
                                overlay={modTool}
                            >

                                <Button
                                    className="circular-button edi-sol-but"
                                    circular
                                    color='twitter'
                                    type="button"
                                    icon={'edit'}
                                />

                            </OverlayTrigger>
                        </Link>

                        <Link to={`/reportes/estudiantes-convenio/${dataR.id}`}>
                            <OverlayTrigger
                                placement="top"
                                delay={{ show: 250, hide: 400 }}
                                overlay={modTool2}
                            >

                                <Button
                                    className="circular-button edi-sol-but"
                                    circular
                                    color='twitter'
                                    type="button"
                                    icon={'user'}
                                />

                            </OverlayTrigger>
                        </Link>
                    </>
                }
                </Col>
            </Row>

        );
    };

    return (

        <>

            <Container className="convenios-section interior-solicitudes">
                <Container>
                    <Row>
                        <Col className="buscar-convenio-area" xs={6}>
                            <Form.Control placeholder="Buscar código" />
                            <Button variant="primary">Buscar</Button>{" "}
                        </Col>
                    </Row>
                </Container>

                <Container className="convenio-head-list">
                    <Col xs={3} className="convenio-head-section">Código Institucional</Col>
                    <Col xs={3} className="convenio-head-section"></Col>
                    <Col xs={2} className="convenio-head-section">Fecha</Col>
                    <Col xs={2} className="convenio-head-section">Monto</Col>
                    <Col xs={2} className="convenio-head-section">Acciones</Col>
                </Container>

                <Container className="convenio-body-list solicitudes-body-area">
                    {loading ? (

                        <LoadingComponent content="Cargando códigos..." key={Math.random()} />

                    ) : (

                        convenio.map(
                            (solicitud: {
                                key: number;
                                id: number;
                                convenio: string;
                                fecha: any;
                                monto: number;
                                descuento: number;
                            }) => (

                                <ConvenioItems {...solicitud} />

                            )
                        )

                    )}
                </Container>

                <Container className="pagination-convenios-area">
                    <Pagination>{items}</Pagination>
                </Container>

            </Container>
            {/* 
            <ReporteInscritosXConvenio
                onHide={ ()=> { setModalShow(false)}}
                show={modalShow}
                id={idsol}
                convno={noconv}
            /> */}

        </>

    )
});